<!--
  ReportSectionNotFound.vue  —  Engine E fallback section renderer.
  Purpose: the graceful fallback mounted by ReportViewScreen when a section
    `type` is not in section2cmp (unknown / missing type). Renders the literal
    "not found" marker.

  reconstructed from lacak.io deployed behavior; app-specific contract verbatim,
  internal impl re-authored.

  VERBATIM (f2e5.js):
    - component name ... "report-section-not-found"
    - output ........... literal "not found"
-->
<template>
  <div class="report-section-not-found">not found</div>
</template>

<script>
export default {
  name: 'report-section-not-found',
  props: {
    // Present for a uniform section interface; unused by the fallback.
    section: { type: Object, required: false, default: null },
  },
};
</script>

<style scoped>
.report-section-not-found {
  padding: 8px 12px;
  font-size: 13px;
  opacity: 0.6;
}
</style>
